"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authResponseProperty = exports.version = void 0;
var version = require('../../package.json').version; //eslint-disable-line
exports.version = version;
exports.authResponseProperty = 'RCAuthorizationResponse';
//# sourceMappingURL=Constants.js.map